import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Button, Container, Label } from "reactstrap";
import { useNavigate } from 'react-router-dom';

const Login = () => {
        const API_URL = process.env.REACT_APP_APIURL;
    console.log("API_URL:", API_URL); // Debug log

    const navigate = useNavigate();
  
    const [email, setEmail] = useState("m@gmail.com");
    const [password, setPassword] = useState("admin@123");

    useEffect(() => {
        document.body.classList.add("auth-body-bg");
        return () => {
            document.body.classList.remove("auth-body-bg");
        };
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();

        const data = {
            userEmail: email,
            userPassword: password
        };

        try {
            const res = await fetch(`${`https://api.myhappywheels.com/api`}/user/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (res.status === 200) {
                const result = await res.json(); // Assuming your API sends back user data or token
                localStorage.setItem("authUser", JSON.stringify(result.user)); // Or result.token, etc.
                alert("Login Successfully");
                navigate('/');
            } else {
                alert("Login failed");
            }
        } catch (error) {
            console.error("Login error:", error);
            alert("An error occurred during login.");
        }
    };

    return (
        <React.Fragment>
            <div>
                <Container fluid className="p-0">
                    <Row className="g-0">
                        <Col lg={4}>
                            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                <div className="w-100">
                                    <Row className="justify-content-center">
                                        <Col lg={9}>
                                            <div>
                                                <div className="text-center">
                                                    <a href="/" className="">
                                                        {/* <img src={logodark} alt="" height="20" className="auth-logo logo-dark mx-auto" />
                                                        <img src={logolight} alt="" height="20" className="auth-logo logo-light mx-auto" /> */}
                                                    </a>
                                                    <h4 className="font-size-18 mt-4">Welcome Back!</h4>
                                                    <p className="text-muted">Sign in to continue to Nazox.</p>
                                                </div>

                                                <div className="p-2 mt-5">
                                                    <form className="form-horizontal" onSubmit={handleLogin}>
                                                        <div className="auth-form-group-custom mb-4">
                                                            <i className="ri-user-2-line auti-custom-input-icon"></i>
                                                            <Label htmlFor="username">Email</Label>
                                                            <Input
                                                                type="text"
                                                                className="form-control"
                                                                id="username"
                                                                placeholder="Enter username"
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="auth-form-group-custom mb-4">
                                                            <i className="ri-lock-2-line auti-custom-input-icon"></i>
                                                            <Label htmlFor="userpassword">Password</Label>
                                                            <Input
                                                                type="password"
                                                                className="form-control"
                                                                id="userpassword"
                                                                placeholder="Enter password"
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="form-check">
                                                            <Input type="checkbox" className="form-check-input" id="customControlInline" />
                                                            <Label className="form-check-label" htmlFor="customControlInline">Remember me</Label>
                                                        </div>

                                                        <div className="mt-4 text-center">
                                                            <Button color="primary" className="w-md waves-effect waves-light" type="submit">Log In</Button>
                                                        </div>

                                                        <div className="mt-4 text-center">
                                                            <a href="/forgot-password" className="text-muted"><i className="mdi mdi-lock me-1"></i> Forgot your password?</a>
                                                        </div>
                                                    </form>
                                                </div>

                                                <div className="mt-5 text-center">
                                                    <p>Don't have an account? <a href="/register" className="fw-medium text-primary"> Register </a></p>
                                                    <p>© 2025 RED PIXEL</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>

                        <Col lg={8}>
                            <div className="authentication-bg">
                                <div className="bg-overlay"></div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Login;
